export default __webpack_public_path__ + "static/media/Dentalplanoptions.e13ca487.svg";